module.exports = __webpack_public_path__ + "img/icon_classify08.473c3a34.png";